module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app my-app"
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "recharge-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "input1",
    staticClass: "recharge-ipt",
    attrs: {
      "placeholder": "请输入金额...",
      "maxlength": "16",
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')",
      "onafterpaste": "this.value=this.value.replace(/\\D/g,'')"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "f-strongest recharge-des"
  }, [_vm._v("注： 金额只能输入整数，单次充值金额不超过3000元")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-sub",
    on: {
      "click": _vm.rechargePay
    }
  }, [_c('button', {
    staticClass: "btn-ok",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("确认支付")])]), _vm._v(" "), _c('payConfirm', {
    model: {
      value: (_vm.showPayConfirm),
      callback: function($$v) {
        _vm.showPayConfirm = $$v
      },
      expression: "showPayConfirm"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bc5e6d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/inpatientRecharge/GoRecharge.vue
// module id = 837
// module chunks = 0